import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

export class Empty extends Operator<unknown> {
  constructor() {
    super(LOGIC_OPERATOR.EMPTY, z.unknown().nullish())
  }

  evaluate(factValue: unknown): boolean {
    if ([undefined, null].includes(factValue as never)) return true

    if (typeof factValue === 'string') {
      return factValue.trim().length === 0
    }

    if (Array.isArray(factValue)) {
      return factValue.length === 0
    }

    return false
  }
}
